import type { ComponentProps } from 'react';

import { PreviewSoundProvider } from './MediaSlot';

import { PlatformPreview } from '@/components/ui/platform-preview';

/**
 * `PlatformPreview` for the post editor only: video clips get a sound toggle (see
 * `PreviewSoundProvider` in `MediaSlot.tsx`). Every other caller keeps using `PlatformPreview`
 * directly and stays muted and control-free, as in the platform feed.
 */
export function EditorPlatformPreview(props: ComponentProps<typeof PlatformPreview>): JSX.Element {
  return (
    <PreviewSoundProvider>
      <PlatformPreview {...props} />
    </PreviewSoundProvider>
  );
}
